import { PRIVACY_POLICY_DOCUMENT } from "@-/dev.improve.haniverse.lib.legal";
import { LegalDocumentBody } from "#legal-document-body";

/** The Privacy Policy body. The public website renders the same text at `/privacy`. */
export function PrivacyDocumentBody() {
  return <LegalDocumentBody document={PRIVACY_POLICY_DOCUMENT} />;
}
